import { html, render } from 'lit-html';
import ClubSinkingInput from './input';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';

class ClubSinking {
	constructor() {
		this.init();
	}

	init() {
		this.inputElements = [];
		this.wrapperElement = SelectorEngine.findOne('.js-club-sinking');
		this.clubFacilityError = SelectorEngine.findOne('.js-club-sinking .js-club-sinking-error');
		this.inputWrapper = SelectorEngine.findOne('.js-club-sinking .js-club-sinking-input-wrapper');

		const infoIcon = SelectorEngine.findOne('.js-club-sinking .js-club-facility-table__info');
		const calculateButton = SelectorEngine.findOne('.js-club-sinking-input-wrapper button');
		const inputs = SelectorEngine.find('.js-club-sinking-input-wrapper .js-club-sinking-input');
		for( const inputElement of inputs) {
			const reference = new ClubSinkingInput(inputElement);
			this.inputElements.push( reference );
		}

		EventHandler.on(calculateButton, 'click', () => {
			this.calculate();
		});

		EventHandler.on(infoIcon, 'mouseover', () => {
			this.showInfo();
		});

		EventHandler.on(infoIcon, 'mouseover', () => {
			this.showInfo();
		});

		EventHandler.on(infoIcon, 'mouseout', () => {
			this.hideInfo();
		});

		EventHandler.on(infoIcon, 'click', () => {
			this.toggleInfo();
		});
	}

	showInfo() {
		const InfoTextElement = SelectorEngine.findOne('.js-club-facility-table__info-text', this.wrapperElement);
		InfoTextElement.classList.remove('u-hidden');
	}

	hideInfo() {
		const InfoTextElement = SelectorEngine.findOne('.js-club-facility-table__info-text', this.wrapperElement);
		InfoTextElement.classList.add('u-hidden');
	}

	toggleInfo() {
		const InfoTextElement = SelectorEngine.findOne('.js-club-facility-table__info-text', this.wrapperElement);
		InfoTextElement.classList.toggle('u-hidden');
	}

	generateFacilityRow(reference) {
		const data = reference.getData();
		if(data.count <= 0 ) {
			return html``;
		}
		return html`
			<tr>
				<td>${data.name}</td>
				<td>${data.count}</td>
				<td>${this.formatCurrency(data.total)}</td>
			</tr>
		`;
	}

	generateFacilityFooter(calculateGrandTotal) {
		return html`${this.formatCurrency(calculateGrandTotal)}`;
	}

	generateFundDetailRow(amount, index) {
		return html`
			<tr>
				<td>Year ${index}</td>
				<td>${this.formatCurrency(amount*index)}</td>
			</tr>
		`;
	}

	calculate() {
		const clubTableWrapper = SelectorEngine.findOne('.js-club-facility-table-wrapper', this.wrapperElement);
		const clubFaciltiyTable = SelectorEngine.findOne('.js-club-facility-table', this.wrapperElement);
		const hasAnyError = this.inputElements.some((reference) => reference.hasError);
		if(hasAnyError) {
			this.hideCalculatedInfo();
			return;
		}
		const calculateGrandTotal = this.inputElements.reduce((total, reference) => reference.getTotal() + total, 0);

		if(clubTableWrapper && calculateGrandTotal > 0 ) {
			this.showCalculatedInfo();
			clubTableWrapper.scrollIntoView();
			clubFaciltiyTable.focus();
			this.hideError();
		} else {
			this.hideCalculatedInfo();
			this.showError();
			return;
		}

		if(clubFaciltiyTable) {
			const clubFaciltiyBody = SelectorEngine.findOne('tbody', clubFaciltiyTable);
			const bodyElements = this.inputElements.map((element) => this.generateFacilityRow(element));
			render(bodyElements, clubFaciltiyBody);

			const clubFaciltiyFooter = SelectorEngine.findOne('.js-club-facility-table__tfoot', clubFaciltiyTable);
			const footerElement = this.generateFacilityFooter(calculateGrandTotal);
			render(footerElement, clubFaciltiyFooter);
		}

		const clubYearsTable = SelectorEngine.findOne('.js-club-sinking-years-table', this.wrapperElement);
		if(clubYearsTable) {
			const clubYearsBody = SelectorEngine.findOne('tbody', clubYearsTable);
			const blubYearRows = [...Array.from({length: 10}).keys()].map((__, index) => this.generateFundDetailRow(calculateGrandTotal, index+1));
			render(blubYearRows, clubYearsBody);
		}
	}

	showCalculatedInfo() {
		const clubTableWrapper = SelectorEngine.findOne('.js-club-facility-table-wrapper', this.wrapperElement);
		clubTableWrapper.classList.remove('u-hidden');
	}

	hideCalculatedInfo() {
		const clubTableWrapper = SelectorEngine.findOne('.js-club-facility-table-wrapper', this.wrapperElement);
		clubTableWrapper.classList.add('u-hidden');
	}

	formatCurrency(value) {
		return (+value).toLocaleString('en-GB', {
			style: 'currency',
			currency: 'GBP',
			maximumFractionDigits: 0,
		});
	}

	showError() {
		this.clubFacilityError.classList.add('is-visible');
		this.clubFacilityError.focus();
	}

	hideError() {
		this.clubFacilityError.classList.remove('is-visible');
	}
}

const globalClubSinking = new ClubSinking();
export default globalClubSinking;
